const bluegrays = {
  white: '#ffffff',
  gray1: '#ebeff2',
  gray2: '#e2e8ed',
  gray3: '#d8e0e5',
  gray4: '#c5d1d8',
  gray5: '#b6c3cc',
  gray6: '#a3b5bf',
  gray7: '#96a8b2',
  gray8: '#889aa5',
  gray9: '#748b99',
  gray10: '#677e8c',
  gray11: '#59717f',
  gray12: '#4c6472',
  gray13: '#425866',
  gray14: '#364c59',
  gray15: '#2c404c',
  gray16: '#23343f',
  gray17: '#1b2a33',
  gray18: '#121f26',
  gray19: '#0c1419',
  gray20: '#05090c',
  black: '#000000'
}

const grays = {
  gray1: '#fafafa',
  gray2: '#f2f1f1',
  gray3: '#ecebeb',
  gray4: '#dcdcdc',
  gray5: '#d3d3d3',
  gray6: '#c0c0c0',
  gray7: '#a9a9a9',
  gray8: '#808080',
  gray9: '#696969',
  gray10: '#424242',
  gray11: '#303030',
  gray12: '#212121'
}

export {
  bluegrays,
  grays
}
